import { Injectable } from '@angular/core';
import { CrudService } from "../Services/crud.service"

@Injectable({
  providedIn: 'root'
})
export class LogedInUserService {
  public logedInUser: {
    companyId:"string",    
    email: "string",
    id: "string",
    status: false,
    username: "string",
    roleId: string[]
  };

  constructor(private crudService: CrudService) {     
  }

  set(val){
    this.logedInUser =val;
  }

  getAdmin(): Promise<any> {
    let self = this;
    return new Promise((resolve, reject) => {
      if (!this.logedInUser) {
        self.crudService.get(null, function(response) {        
          self.set(response);
          resolve(self.logedInUser);
        }, 'userManagements/'+ localStorage.getItem("userId"));
      } else {
        resolve(self.logedInUser);
      }
    });
  }

  get(callback) {
    let self = this;
    if (!this.logedInUser) {
        self.crudService.get(null,function(response) {        
          self.set(response);
          callback(self.logedInUser);
        }, 'userManagements/'+ localStorage.getItem("userId"));
    } else {
      callback(self.logedInUser);
    }
  }
}
